import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ContactoPage } from '../pages/ContactoPage';
import '../styles.css';

const container = document.getElementById('app')!;
createRoot(container).render(
  <StrictMode>
    <ContactoPage />
  </StrictMode>,
);
